import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-21edcbd8")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "export_action" }
const _hoisted_3 = { class: "p-d-flex" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "p-mb-3 p-text-bold" }
const _hoisted_8 = { class: "p-d-flex p-ai-center p-flex-nowrap" }
const _hoisted_9 = { class: "p-mb-3 p-text-bold" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("small", null, [
    /*#__PURE__*/_createElementVNode("i", null, "(HH:mm:ss)")
  ])
], -1)
const _hoisted_11 = { class: "p-mb-3 p-text-bold" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TicketsFilters = _resolveComponent("TicketsFilters")!
  const _component_SplitButton = _resolveComponent("SplitButton")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MaterialSelect = _resolveComponent("MaterialSelect")!
  const _component_TicketStatus = _resolveComponent("TicketStatus")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PaymentStatus = _resolveComponent("PaymentStatus")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_CurrencyText = _resolveComponent("CurrencyText")!
  const _component_TicketFinishStatus = _resolveComponent("TicketFinishStatus")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _component_TicketDisputeResolverDialog = _resolveComponent("TicketDisputeResolverDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ticket.list.title')), 1)
    ]),
    _createVNode(_component_TicketsFilters, {
      filters: _ctx.advFilters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters = $event)),
      onChange: _ctx.onFiltersChange
    }, null, 8, ["filters", "onChange"]),
    _createVNode(_component_AppTable, {
      ref: "table",
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      showActions: false,
      rowClass: _ctx.rowClass,
      onResetFilters: _ctx.onReset,
      onRowClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDetail($event.data)))
    }, {
      toolbarLeft: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_SplitButton, {
            icon: 'pi ' + (_ctx.exporting ? 'pi-spin pi-spinner' : 'pi-file-excel'),
            disabled: _ctx.exporting,
            label: "Export",
            model: _ctx.exports
          }, null, 8, ["icon", "disabled", "model"])
        ])
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, { header: "Actions" }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createVNode(_component_Button, {
                class: "p-button-info p-mr-1",
                icon: "pi pi-eye",
                onClick: _withModifiers(($event: any) => (_ctx.onEdit(data)), ["stop"])
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('open'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              (_ctx.canDelete(data))
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-danger p-mr-1",
                    icon: "pi pi-trash",
                    label: _ctx.trashLabel(data),
                    onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
                  }, null, 8, ["label", "onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('delete'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "id",
          showFilterMatchModes: false,
          header: _ctx.$t('ticket.table.id'),
          style: {"min-width":"8rem"}
        }, {
          filter: _withCtx(({filterModel, filterCallback}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: "Search by ticket ID",
              onKeyup: _withKeys(($event: any) => (onApplyFilter(filterCallback)), ["enter"])
            }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeyup"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(" #" + _toDisplayString(data.id), 1)
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.date'),
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.ticket_day), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.shift'),
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_router_link, {
              to: {
              name: _ctx.shiftRoute,
              params: { shiftId: data.shift_id }
            },
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" #" + _toDisplayString(data.shift_id) + " " + _toDisplayString(data.shift?.code), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: "Customer",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            (_ctx.isColLinksActive)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
              name: _ctx.customerDetailRoute,
              params: { companyId: data.customer?.id }
            },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.customer?.name || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(data.customer?.name || '-'), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Broker",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            (_ctx.isColLinksActive)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
              name: _ctx.brokerDetailRoute,
              params: { companyId: data.broker?.id }
            },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.broker?.business_name || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(data.customer?.name || '-'), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Client",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            (_ctx.isColLinksActive)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: {
              name: _ctx.clientDetailRoute,
              params: { companyId: data.client?.id }
            },
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(data.client?.name || '-'), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(data.client?.name || '-'), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.name'),
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.user.name) + " " + _toDisplayString(data.user.surname), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.zone_load'),
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.shift.zone_load?.name), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.dump_site'),
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.shift.zone_dump?.name), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.table.job_site'),
          field: 'shift.job_site',
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: _ctx.$t('ticket.table.filters.by_job_site')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.shift.job_site), 1)
          ]),
          _: 2
        }, 1032, ["header", "field"]),
        _createVNode(_component_Column, {
          field: "material_id",
          header: _ctx.$t('ticket.table.materials'),
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('ticket.table.filters.by_materials')), 1),
            _createVNode(_component_MaterialSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event)
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.shift.material?.name), 1)
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          field: "cost_code",
          header: _ctx.$t('ticket.table.cost_code'),
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_InputText, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              placeholder: _ctx.$t('ticket.table.filters.by_cost_code')
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-times",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.shift.cost_code), 1)
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          header: _ctx.$t('ticket.total_ton'),
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.total_ton || '-'), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "status",
          header: _ctx.$t('ticket.table.status'),
          showFilterMatchModes: false,
          showFilterOperator: false,
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_TicketStatus, {
                status: data.status
              }, null, 8, ["status"]),
              (_ctx.isDispute(data))
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button-rounded p-button-info p-ml-1",
                    icon: "pi pi-comment",
                    onClick: ($event: any) => (_ctx.onResolve(data))
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('resolve dispute'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ])
          ]),
          filter: _withCtx(({filterModel}) => [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('ticket.table.filters.by_status')), 1),
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              placeholder: "Select statuses",
              optionLabel: "label",
              "option-value": "value",
              maxSelectedLabels: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          field: "payment_status",
          header: _ctx.$t('ticket.table.payment_status'),
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _createVNode(_component_Dropdown, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.paymentStatusOptions,
              placeholder: "Select Status",
              "option-value": "value",
              "option-label": "label"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.clear'),
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.apply'),
              class: "p-button-success",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createVNode(_component_PaymentStatus, {
              status: data.payment_status
            }, null, 8, ["status"])
          ]),
          _: 2
        }, 1032, ["header"]),
        _createVNode(_component_Column, {
          field: "datetime_assigned",
          header: _ctx.$t('ticket.table.start_date'),
          style: {"min-width":"12rem"},
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.datetime_start,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "datetime_end",
          header: _ctx.$t('ticket.table.end_date'),
          style: {"min-width":"12rem"},
          sortable: true
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.datetime_end,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, null, {
          header: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('ticket.table.duration')), 1),
              _hoisted_10
            ])
          ]),
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(_ctx.getDuration(data)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "cycles",
          header: _ctx.$t('ticket.table.cycles'),
          sortable: true
        }, null, 8, ["header"]),
        (_ctx.visibilityCols.fee_driver)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              field: "fee_driver",
              header: _ctx.$t('ticket.table.fee_driver'),
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.fee_driver
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.visibilityCols.fee_broker)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 1,
              field: "fee_broker",
              header: _ctx.$t('ticket.table.fee_broker'),
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.fee_broker
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.visibilityCols.fee_customer)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 2,
              field: "fee_customer",
              header: _ctx.$t('ticket.table.fee_customer'),
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.fee_customer
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.visibilityCols.fee_system)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 3,
              field: "fee_system",
              header: _ctx.$t('ticket.table.fee_system'),
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.fee_system
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        (_ctx.visibilityCols.fee_client)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 4,
              field: "fee_client",
              header: _ctx.$t('ticket.table.fee_client'),
              style: {"min-width":"10rem"}
            }, {
              body: _withCtx(({data}) => [
                _createVNode(_component_CurrencyText, {
                  modelValue: data.fee_client
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["header"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Column, {
          field: "finish_status",
          header: _ctx.$t('ticket.table.final_status'),
          showFilterMatchModes: false,
          showFilterOperator: false,
          style: {"min-width":"10rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_TicketFinishStatus, { ticket: data }, null, 8, ["ticket"])
          ]),
          filter: _withCtx(({filterModel}) => [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('ticket.table.filters.by_status')), 1),
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.finishStatusOptions,
              placeholder: "Select statuses",
              optionLabel: "label",
              "option-value": "value",
              maxSelectedLabels: 2
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          _: 2
        }, 1032, ["header"])
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "rowClass", "onResetFilters"]),
    _createVNode(_component_TicketDisputeResolverDialog, {
      ticket: _ctx.selectedTicket,
      visible: _ctx.displayResolverDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayResolverDialog = $event)),
      header: "Resolve dispute - Refund",
      onResolved: _ctx.onResolved,
      onCancel: _ctx.onResolveCancel
    }, null, 8, ["ticket", "visible", "onResolved", "onCancel"])
  ]))
}